import App from '@/app.js'

import useMediaBreckpoint from '@utils/media-breakpoints.js'

const { $mediaBreackpointUp, $mediaBreackpointDown } = useMediaBreckpoint()

// Remove os caracteres não numéricos do telefone
const parseFone    = fone => fone.replace(/\D/g, '')

// Encode o texto para URL
const parseText    = text => encodeURI(text)

// Gera os params de url
const whatsappParams = ({fone, text}) => {
	let params = new URLSearchParams([])

	if(fone) {
		params.append('phone', `55${parseFone(fone)}`)
	}

	if(text) {
		params.append('text', parseText(text))
	}

	return params
}

// Gera o link Mobile
const mobileLink   = (fone, text) => {
	const params = whatsappParams({fone, text})
	return `https://api.whatsapp.com/send?${params.toString()}`
}

// Gera o link Desktop
const desktopLink  = (fone, text) => {
	const params = whatsappParams({fone, text})
	return `https://web.whatsapp.com/send?${params.toString()}`
}


/*
	Registrando globalmente a diretiva
	Ex de uso:
	<a
		href="#"
		v-whatsapp-link
		data-fone="(99) 9.1234-5678"
		data-text="Olá, eu vim pelo site"
	>...</a>
*/
App.directive('whatsapp-link', (el, bindind) => {
	const fone = el.dataset.fone
	const text = el.dataset.text

	const mobile  = mobileLink(fone, text)
	const desktop = desktopLink(fone, text)

	el.removeAttribute('data-fone')
	el.removeAttribute('data-text')

	$mediaBreackpointDown('lg', () => {
		el.setAttribute(
			'href',
			mobile
		)
	})

	$mediaBreackpointUp('lg', () => {
		el.setAttribute(
			'href',
			desktop
		)
	})
})
